import React from "react";
import { PageHeader } from "../../components/Header";
import { PageWrapper } from "../../components/Page";
import { Button } from "../../components/Button";
import {
  ArrowBack,
  ArrowForward,
  ShoppingCart,
  OpenInNew,
} from "@material-ui/icons";
import { ProjectExpander } from "../Project";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { IProject } from "../../reducers/project";
import { useDispatch, useSelector } from "react-redux";
import { getCart, getHistory } from "../../reducers/project/selectors";
import { ProjectActions } from "../../reducers/project/actionsNames";
import Scrollbars from "react-custom-scrollbars";
import content from "../../content";
import { DrawerMenu } from "../../components/Menu";
import { useDesktop } from "../../components/Responsive";

const Label = styled.div`
  height: 55px;
  border-top: 1px solid #aaaaaa;
  display: flex;
  align-items: center;
  padding: 0px 20px;
  font-weight: bold;
  font-size: 18px;
`;

function ProjectHistory({}: IProjectsCart) {
  const history: IProject[] = useSelector(getHistory);
  const dispatch = useDispatch();

  const reset = () => dispatch({ type: ProjectActions.Reset });

  const desktop = useDesktop();

  return (
    <>
      <PageHeader header={content.getValue("header_history")} />
      <PageWrapper
        padding={desktop ? "32px 40px" : "16px 16px"}
        menu={<>
          <DrawerMenu
            Icon={
              <svg
                width="42"
                height="42"
                viewBox="0 0 42 42"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="21" cy="21" r="21" fill="#080808" />
                <path
                  d="M12.3125 29.25C12.3125 29.984 12.899 30.5769 13.625 30.5769H29.375C30.101 30.5769 30.6875 29.984 30.6875 29.25V17.3077H12.3125V29.25ZM18.875 20.4591C18.875 20.1855 19.0965 19.9615 19.3672 19.9615H23.6328C23.9035 19.9615 24.125 20.1855 24.125 20.4591V20.7909C24.125 21.0645 23.9035 21.2885 23.6328 21.2885H19.3672C19.0965 21.2885 18.875 21.0645 18.875 20.7909V20.4591ZM30.6875 12H12.3125C11.5865 12 11 12.593 11 13.3269V15.3173C11 15.6822 11.2953 15.9808 11.6562 15.9808H31.3438C31.7047 15.9808 32 15.6822 32 15.3173V13.3269C32 12.593 31.4135 12 30.6875 12Z"
                  fill="white"
                />
              </svg>
            }
            title={content.getValue("drawer_project_history_title")}
            text={content.getValue("drawer_project_history_text")}
          />
          <div style={{display: 'flex', width: '100%', paddingLeft: '24px', boxSizing: "border-box"}}>
            <div style={{
              boxSizing: "border-box",
              padding: "0px 24px 24px 0px",
              width: '50%'
            }}>
              <Link to={'/'}>
                <Button
                  startIcon={
                    <svg width="17" height="8" viewBox="0 0 17 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0.646446 4.35355C0.451185 4.15829 0.451185 3.84171 0.646446 3.64645L3.82843 0.464466C4.02369 0.269204 4.34027 0.269204 4.53553 0.464466C4.7308 0.659728 4.7308 0.976311 4.53553 1.17157L1.70711 4L4.53553 6.82843C4.7308 7.02369 4.7308 7.34027 4.53553 7.53553C4.34027 7.7308 4.02369 7.7308 3.82843 7.53553L0.646446 4.35355ZM17 4.5H1V3.5H17V4.5Z" fill="#838282"/>
                    </svg>

                  }
                  variant={"text"}
                  label={content.getValue("button_back_to_creator")} /></Link>
            </div>
          </div>
        </>
        }
      >
        <div
          style={{
            display: "flex",
            height: `calc(100vh - ${desktop ? 267 : 145}px)`,
            maxHeight: `calc(100vh - ${desktop ? 267 : 145}px)`,
          }}
        >
          <Scrollbars
            autoHeight={true}
            autoHeightMin={"100%"}
            autoHeightMax={"100%"}
          >
            {history.map((h) => (
              <ProjectExpander history={true} project={h} />
            ))}
            <Link to={"/"} onClick={reset}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  height: "70px",
                  marginBottom: "25px",
                  border: "2px dashed #C41230",
                  boxSizing: "border-box",
                  cursor: "pointer",
                }}
              >
                <svg
                  style={{ marginRight: "5px" }}
                  width="26"
                  height="26"
                  viewBox="0 0 26 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle opacity="0.1" cx="13" cy="13" r="13" fill="#C41230" />
                  <line
                    x1="7"
                    y1="12.7858"
                    x2="18"
                    y2="12.7858"
                    stroke="#C41230"
                    stroke-width="2"
                  />
                  <line
                    x1="12.7145"
                    y1="7.5"
                    x2="12.7145"
                    y2="18.5"
                    stroke="#C41230"
                    stroke-width="2"
                  />
                </svg>

                {content.getValue("button_new_project")}
              </div>
            </Link>
          </Scrollbars>
        </div>
      </PageWrapper>
    </>
  );
}

export interface IProjectsCart {}

export default ProjectHistory;
